import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { CommonAtcExcelModel } from 'src/app/model/common/atc-upload';
import { CommonAtcViewModel } from 'src/app/model/common/atc.view';
import { environment } from 'src/environments/environment';
import { commonAtcActions } from '../../../store/common/atc/atc.action';

@Injectable({
  providedIn: 'root',
})
export class CommonAtcService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  getLazyLoad = (): Observable<VonPageResponseModel<CommonAtcViewModel>> =>
    this.store.select('common', 'atc', 'result');

  getLoad = (): Observable<CommonAtcViewModel[]> =>
    this.store.select('common', 'atc', 'plain');

  readPaged = (
    page: number,
    size: number,
    query: string
  ): Observable<VonPageResponseModel<CommonAtcViewModel>> =>
    this.rest
      .get<VonPageResponseModel<CommonAtcViewModel>>({
        url: `${environment.endpoints.common}/atc/paged`,
        params: { page, size, query },
      })
      .pipe(
        tap({
          next: (result) =>
            this.store.dispatch(
              commonAtcActions.setPagedResultAction({ result })
            ),
        })
      );

  readList = (
    level: number = 1,
    parent?: string
  ): Observable<CommonAtcViewModel[]> => {
    const params: any = {
      level,
    };
    if (parent) {
      params.parent = parent;
    }
    return this.rest
      .get<CommonAtcViewModel[]>({
        url: `${environment.endpoints.common}/atc`,
        params,
      })
      .pipe(
        tap((result) => {
          if (!parent) {
            this.store.dispatch(
              commonAtcActions.setListResultAction({ result })
            );
          }
        })
      );
  };

  uploadFile = (file: File): Observable<CommonAtcExcelModel> => {
    const formData = new FormData();
    formData.append('excel', file);
    return this.rest.post<CommonAtcExcelModel>({
      url: `${environment.endpoints.common}/atc/upload`,
      body: formData,
    });
  };
}
